module.exports = __webpack_public_path__ + "er.ed8466e0.svg";